/**
 * Centralized configuration for GLS wetags.
 * Change these values to update the namespace and tag name across the entire application.
 */

export const GLS_WETAG_CONFIG = {
  /**
   * The namespace for GLS-related wetags.
   * Used for all workspace-related feature flags.
   */
  NAMESPACE: 'gls' as const,

  /**
   * The tag name for workspace features.
   * Controls access to workspace functionality across the application.
   */
  TAG_NAME: 'workspace' as const,
} as const;

/**
 * Type-safe accessor for the workspace tag name
 */
export type GlsTagName = typeof GLS_WETAG_CONFIG.TAG_NAME;
